import { CircularProgress, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { rdsTabulate } from '../../modules/rds';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import { composeWhereClause } from '../../modules/data';

function Access() {
  const { stateCode } = useParams();

  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [capacity, setCapacity] = useState(null);

  useEffect(() => {
    setReady(false);
    setError(null);

    function getCapacity() {
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND capacity_type=LIC`;
      whereClause += composeWhereClause({});

      return rdsTabulate('ccdc', 'county_licensed_capacity', {
        dims: 'state',
        measure: 'capacity:SUM(capacity)',
        where: whereClause,
        format: 'amcharts',
      });
    }

    Promise.all([getCapacity()])
      .then((responses) => {
        // console.log(responses)
        setCapacity(responses[0].parsedBody.dataProvider[0].capacity);
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode]);

  if (!ready) {
    return <CircularProgress />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      <Typography variant="body1">
        In <b>{states[stateCode.toUpperCase()]}</b>, there are <b>{toFormattedNumber(capacity)}</b> child care slots. The number of slots varies by setting type and child age.
      </Typography>
    </>
  );
}

export default Access;
